import time from "src/utils/time";
import { useTranslation } from "react-i18next";
import { Flex, Box } from "@chakra-ui/react";
import CorrespondingAvatar from "src/modules/avatar/components/CorrespondingAvatar";
import MonitoringShare from "./MonitoringShare";
import { Overline2, H4, Caption } from "src/atoms/typography";

export default function Metadata({ deviceName, duration, avatar, toggleShare, monitoring }) {
  const { t } = useTranslation();
  return (
    <Flex justifyContent="space-between" alignItems="center">
      <Box>
        <Flex alignItems="center">
          <Overline2
            color="lowEmphasis"
            textTransform="uppercase"
            maxWidth="155px"
            overflow="hidden"
            textOverflow="ellipsis"
            whiteSpace="nowrap"
          >
            {deviceName}
          </Overline2>
          {avatar && (
            <Flex alignItems="center" width="140px" ml="8px" columnGap="8px">
              <CorrespondingAvatar width="18px" height="18px" avatar={avatar} />
              <Caption
                maxWidth="100%"
                overflow="hidden"
                textOverflow="ellipsis"
                whiteSpace="nowrap"
                color="lowEmphasis"
              >
                {avatar?.name?.toUpperCase()}
              </Caption>
            </Flex>
          )}
        </Flex>
        <H4 color="highEmphasis">
          {t("activityLog.monitoringDetail.metadata.totalTime", {
            value0: time.duration(duration).format("h _ m _ s _", { largest: 2 })
          })}
        </H4>
      </Box>
      <MonitoringShare monitoring={monitoring} toggleShare={toggleShare} />
    </Flex>
  );
}
